import './dashboard.layout.scoped.sass';
import React from 'react';
import { SideNavComponent } from 'src/components/sidenav/sidenav.component';

export default function DashboardLayout (props: any) {
    return (
        <div className="dashboard-layout">
            <SideNavComponent />
            <div className="content">
                { props.children }
            </div>
        </div>
    )
}